module.exports = {
  OFFER: "discount offer",
  OFFER_MSG: "The festive sale of the year will offer upto 45% off",
  EMAIL_EMPTY: "Email field cannot be empty.",
  PAYMENT_OPTION: "Please choose the payment option",
  TERMSCONDITION: "Please accept the terms and condition",
};
